import { connect } from 'react-redux';
import ErrorPage, { IErrorPageStoreProps } from './error-page.component';
import { IState } from 'modules/event-manager/event-manager.reducer';

const mapStateToProps = (state: { event: IState }): IErrorPageStoreProps => ({
    errorType: state.event.error!.type!
});

const ErrorPageContainer = connect(mapStateToProps)(ErrorPage);
export default ErrorPageContainer;
